export const openSlrPrintPreview = async (element, filename) => {
	if (!element) throw new Error('SLR_PDF_CONTENT_MISSING')

	const pdfTab = window.open('about:blank', '_blank')
	if (!pdfTab) throw new Error('SLR_PDF_OPEN_FAILED')

	try {
		pdfTab.opener = null
		const printDocument = pdfTab.document
		printDocument.title = filename
		printDocument.documentElement.lang = document.documentElement.lang

		const base = printDocument.createElement('base')
		base.href = document.baseURI
		printDocument.head.appendChild(base)

		const stylesheetLoads = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]')).map(stylesheet => {
			const copy = printDocument.importNode(stylesheet, true)
			const loaded = copy.tagName === 'LINK'
				? new Promise((resolve, reject) => {
					copy.onload = resolve
					copy.onerror = () => reject(new Error('SLR_PRINT_STYLES_FAILED'))
				})
				: Promise.resolve()
			printDocument.head.appendChild(copy)
			return loaded
		})

		const pageStyle = printDocument.createElement('style')
		pageStyle.textContent = '@page { size: A4 portrait; margin: 5mm; } body { margin: 0; padding: 5mm; background: #fff; } @media print { body { padding: 0; } }'
		printDocument.head.appendChild(pageStyle)

		const content = printDocument.importNode(element, true)
		content.style.display = 'block'
		content.style.width = '100%'
		content.style.maxWidth = '100%'
		content.style.margin = '0'
		printDocument.body.appendChild(content)

		await Promise.all(stylesheetLoads)
		if (pdfTab.closed) return
		if (printDocument.fonts) await printDocument.fonts.ready
		await Promise.all(Array.from(content.querySelectorAll('img')).map(image => image.complete
			? Promise.resolve()
			: new Promise(resolve => {
				image.onload = resolve
				image.onerror = resolve
			})))

		if (pdfTab.closed) return
		pdfTab.focus()
		pdfTab.print()
	} catch (error) {
		if (!pdfTab.closed) pdfTab.close()
		throw error
	}
}